import { StepName } from '@/state/state.types';

type IsConsultationFromStatic = {
  stepName?: StepName;
};

export default function isConsultationFromStatic({ stepName }: IsConsultationFromStatic): boolean {
  switch (stepName) {
    case StepName.product:
    case StepName.congrats_first_step:
    case StepName.checkout:
    case StepName.in_collections:
    case StepName.consult_focus:
      return true;
    default:
      return false;
  }
}
